import { httpClient } from '~/utils/axios'

export default ({ store, redirect, route }) => {
  httpClient.interceptors.request.use(
    (config) => {
      if (store.getters['auth/isLogin']) {
        config.headers = { Authorization: store.state.auth.authToken }
      }
      return config
    },
    (error) => {
      if (error.response && error.response.status === 500) {
        alert('通信エラーが発生しました')
        return Promise.reject(error)
      }
    }
  )

  httpClient.interceptors.response.use(
    (res) => {
      // バージョン確認してローカルのAPIバージョンが古かったらバージョンアップ画面に飛ばす
      const current_api_version = process.env.API_VERSION
      console.log("interceptors response", res.data.api_version, current_api_version)
      if (res.data.api_version && res.data.api_version > current_api_version) {
        if (route.path !== '/version_up/') redirect('/version_up/')
      }

      // レスポンスを見て処理を変更
      if (res.data.status === 'success'){
        return res
      }else{
        // silentAuthError: 呼び出し側が「無効なら自分で取り直す」ための確認リクエスト
        // （LINE 入口の mixins/lineEntry.js）。ログアウト・エラー表示をせずにそのまま返す
        if (res.data.status === 'not_authenticated' && res.config && res.config.silentAuthError) {
          return res
        }
        if (res.data.status === 'not_authenticated') store.commit('auth/logout')
        // silentError: 呼び出し側が失敗理由を自分の画面で出すリクエスト（解錠の状態の帯など）。
        // 共通の赤いスナックバーを重ねない（ログアウトは上で従来どおり行う）
        if (res.config && res.config.silentError) return res
        if (res.data.message) {
          // ログアウトの理由はログイン画面（別レイアウト）でも見えるよう、レイアウトを跨ぐ通知で出す（C9）
          const mutation = res.data.status === 'not_authenticated' ? 'alert/setLogoutReason' : 'alert/setError'
          store.commit(mutation, res.data.message)
        }
        return res
      }
    },
    (error) => {
      // Any status codes that falls outside the range of 2xx cause this function to trigger
      // Do something with response error
      return Promise.reject(error);
    });
}
